import * as React from 'react';
import {
  Container,
  Box,
  ListItemText,
  ListSubheader,
  List,
  Typography,
  Button
} from '@mui/material';
import useStore from '../state-files/zustondStoreStates';
import useMessagesStore from '../state-files/useMessagesStore';
import Review from '../Components/Review';
import CommunityDiscussionComponent from '../Components/CommunityDiscussionComponent';
import { apiUrlPrefix } from '../../../config';
import { useMediaQuery } from "@mui/system";
import fetchManagerReports from '../helper-methods/fetchManagerReports';
import SuspendedUsers from './SuspendedUsers';
import HeaderBar from '../Components/Static/HeaderBar';

const ModerationScreen = ({ communityId }) => {
  const [reports, setReports] = React.useState([]);
  const { currentCommunityId } = useStore(); // Use zustand store
  const { currentDiscussionId, setIsLoggedIn } = useStore();
  const isMobile = useMediaQuery('(max-width:1300px)');
  const [removedDiscussions, setRemovedDiscussions] = React.useState({});
  const { isHidden, setIsHidden } = useStore();

  React.useEffect(() => {
    fetchManagerReports(currentDiscussionId, currentCommunityId, setReports);
  }, [currentDiscussionId, communityId, setReports]);

  const suspendUser = async (userId) => {
    var newCommunityId = (currentCommunityId === undefined) ? '' : currentCommunityId;
    var newDiscussionId = (currentDiscussionId === undefined) ? '' : currentDiscussionId;

    const apiUrl = apiUrlPrefix + 'Report/SuspendUser';
    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: userId,
        communityId: newCommunityId,
        discussionId: newDiscussionId,
      }),
    });

    if (response.ok) {
      return response.status;
    } else if (response.status === 304 || response.status === 400) {
      return 304; //It is not modified
    }
  }

  const completeAction = async (reportId) => {
    const apiUrl = apiUrlPrefix + 'Report/CompleteReport';
    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: reportId,
      }),
    });
    if (response.ok) {
      return response.status;
    }
  }

  return (
    <>
      <HeaderBar isLoggedIn={true} />
      <SuspendedUsers />
      <Box
        className={isHidden === 0 ? '' : 'hidden'}
        sx={{ flexGrow: 1, padding: 2 }}
      >
        <Container>
          {/* This is used to manage the header component when a user clicks a community, this will not appear if they are just in the discussions tab */}
          <CommunityDiscussionComponent currentCommunityId={currentCommunityId} />
          <p></p>
          <List
            sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: '5px', boxShadow: 1 }}
            component="nav"
            subheader={
              <ListSubheader
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  py: 1,
                  borderBottom: '1px solid #eee'
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Moderation Panel
                </Typography>
                <p />

                {/* Create Discussion button */}
                <Typography variant="subtitle1"
                  sx={{
                    fontWeight: 'bold', border: '1px solid black', borderRadius: '10px',            // 1. Glossy Gradient (Light Green to Primary Green)
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(40, 165, 52, 0.5) 100%)',
                    backgroundColor: 'rgba(129, 199, 132, 0.5)', // The "Lighter" base color

                    // 2. Glassmorphism Effects
                    backdropFilter: 'blur(4px)', // Softens the background behind the button
                    border: '1px solid rgba(255, 255, 255, 0.3)', // Soft white border for depth

                    // 3. Shadow for "Pop"
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                    // 4. Text Styling
                    color: 'white', // Darker green text for readability
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    borderRadius: '12px',
                    px: 1,
                    py: 1,
                    cursor: 'pointer',

                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(40, 165, 52, 0.4) 100%)',
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                    }
                  }}
                  onClick={() => {
                    setIsHidden(1); //Send to suspended user list
                  }}>
                  Suspended Users
                </Typography>


                {/* Place the actual widget here so it can listen for the state change */}

              </ListSubheader>
            }
          >
            {reports
              .map((reportedItem, index) => {
                const wantsToSuspend = removedDiscussions[reportedItem.id];
                return (
                  <Box sx={{ width: '100%', p: 1 }}>
                    <ListItemText
                      primary={"Report Id: " + reportedItem.id || "Unknown"}
                      sx={{ textAlign: 'left' }}
                    />
                    <ListItemText
                      primary={"User: " + reportedItem.userId || "Unknown"}
                      sx={{ textAlign: 'left' }}
                    />
                    <ListItemText
                      primary={"Message: " + reportedItem.reportedMessage || "Unknown"}
                      sx={{ textAlign: 'left' }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                      <Button sx={{
                        fontWeight: 'bold', border: '1px solid black', borderRadius: '10px',            // 1. Glossy Gradient (Light Green to Primary Green)
                        background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(40, 165, 52, 0.5) 100%)',
                        backgroundColor: 'rgba(129, 199, 132, 0.5)', // The "Lighter" base color

                        // 2. Glassmorphism Effects
                        backdropFilter: 'blur(4px)', // Softens the background behind the button
                        border: '1px solid rgba(255, 255, 255, 0.3)', // Soft white border for depth

                        // 3. Shadow for "Pop"
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                        // 4. Text Styling
                        color: 'white', // Darker green text for readability
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        borderRadius: '5px',
                        px: 0.8,
                        py: 0.1,
                        cursor: 'pointer',

                        transition: 'all 0.3s ease',
                        '&:hover': {
                          background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(40, 165, 52, 0.4) 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                        }
                      }} onClick={() => {
                        completeAction(reportedItem.id);
                        const newReports = reports.filter((reports) => reports.id !== reportedItem.id);
                        setReports(newReports);

                      }}>Complete</Button>

                      <Button sx={{
                        fontWeight: 'bold', border: '1px solid black', borderRadius: '10px',            // 1. Glossy Gradient (Light Green to Primary Green)
                        background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(40, 165, 52, 0.5) 100%)',
                        backgroundColor: 'rgba(129, 199, 132, 0.5)', // The "Lighter" base color

                        // 2. Glassmorphism Effects
                        backdropFilter: 'blur(4px)', // Softens the background behind the button
                        border: '1px solid rgba(255, 255, 255, 0.3)', // Soft white border for depth

                        // 3. Shadow for "Pop"
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                        // 4. Text Styling
                        color: 'white', // Darker green text for readability
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        borderRadius: '5px',
                        px: 0.8,
                        py: 0.1,
                        cursor: 'pointer',

                        transition: 'all 0.3s ease',
                        '&:hover': {
                          background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(40, 165, 52, 0.4) 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                        }
                      }} onClick={() => {
                        if (!wantsToSuspend) {
                          setRemovedDiscussions(prev => ({
                            ...prev,
                            [reportedItem.id]: true //Mark this as wanting to delete
                          }));
                          return;
                        } else {
                          // Inside your delete function
                          suspendUser(reportedItem.reportedUserId)
                          const newReports = reports.filter((reports) => reports.id !== reportedItem.id);
                          setReports(newReports);
                        }
                      }}>{(wantsToSuspend) ? "Confirm" : "Suspend"}</Button>
                    </Box>
                  </Box>
                )
              })}
          </List>

          <Review />
          {isMobile ? (
            <Box sx={{
              flex: 1,
              display: 'flex',          // This "turns on" the centering powers
              flexDirection: 'row',
              alignItems: 'center',     // Centers horizontally
              justifyContent: 'center',  // Centers vertically
              width: '100%'
            }}>
            </Box>
          ) : null}
        </Container>
      </Box>
    </>
  );
};

export default ModerationScreen;